export default __webpack_public_path__ + "static/media/10_briefcase-2.49af4227.jpg";